module.exports = __webpack_public_path__ + "static/media/SuperbillTemplate.545305de.txt";